import React from "react";
import OrgChart from "@dabeng/react-orgchart";
import "./styles/OrgChart.css";
import PageOverView from "../components/Page Overview";
import Breadcrumb from "../components/BreadCrumb";
import { motion } from 'framer-motion';

const text = "Organization Chart";

const paths = [
    { name: 'Home', link: '/' },
    { name: 'Organization Chart', link: '' },
];

const OrgChartPage = () => {
    const orgData = {
        id: 1,
        name: "Director",
        title: "CEO",
        image: "./img/services/seo-optimization/increased-website-traffic.png",
        children: [
            {
                id: 2,
                name: "Web Development Team",
                title: "Head of Web Development",
                image: "https://example.com/head-development.jpg",
                children: [
                    {
                        id: 3,
                        name: "Developer A",
                        title: "Frontend Developer",
                        image: "https://example.com/developer-a.jpg",
                    },
                    {
                        id: 4,
                        name: "Developer B",
                        title: "Backend Developer",
                        image: "https://example.com/developer-b.jpg",
                    },
                ],
            },
            {
                id: 5,
                name: "AI Team",
                title: "Head of AI",
                image: "https://example.com/head-marketing.jpg",
                children: [
                    {
                        id: 6,
                        name: "Developer C",
                        title: "Social Media Manager",
                        image: "https://example.com/marketer-a.jpg",
                    },
                    {
                        id: 7,
                        name: "Developer D",
                        title: "SEO Specialist",
                        image: "https://example.com/marketer-b.jpg",
                    },
                ],
            },
            {
                id: 8,
                name: "Dynamics 365 Team",
                title: "Head of Dynamics 365",
                image: "https://example.com/head-hr.jpg",
                children: [
                    {
                        id: 9,
                        name: "Developer E",
                        title: "Recruiter",
                        image: "https://example.com/hr-a.jpg",
                    },
                    {
                        id: 10,
                        name: "Developer F",
                        title: "HR Manager",
                        image: "https://example.com/hr-b.jpg",
                    },
                    {
                        id: 11,
                        name: "Developer G",
                        title: "HR Manager",
                        image: "https://example.com/hr-b.jpg",
                    },
                ],
            },
        ],
    };

    return (
        <>
            <div className="page-overview">
                <PageOverView text={text} />
            </div>
            <div className="org-chart-container">
                <motion.div
                    key="div0"
                    initial={{ opacity: 0, x: -100 }}
                    animate={{ opacity: 1, x: 0 }}
                    exit={{ opacity: 0, x: 100 }}
                    transition={{ duration: 0.7 }}
                >
                    <OrgChart
                        datasource={orgData}
                        chartClass="my-org-chart"
                        NodeTemplate={({ nodeData }) => (
                            <div className="custom-node">
                                <img src={nodeData.image} alt={nodeData.name} className="node-image" />
                                <h4>{nodeData.name}</h4>
                                <p>{nodeData.title}</p>
                            </div>
                        )}
                    />
                </motion.div>
            </div>
            <div className="breadcrumb-container">
                <Breadcrumb paths={paths} />
            </div>
        </>
    );
};

export default OrgChartPage;
